import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-438391d1"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  style: {
    "display": "flex",
    "flex-flow": "row nowrap"
  }
};
var _hoisted_2 = {
  class: "GHGroup"
};
var _hoisted_3 = {
  class: "GHGroupTitle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_GHSubGroup = _resolveComponent("GHSubGroup");

  var _directive_loading = _resolveDirective("loading");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("div", {
    class: "OperatorLayout",
    style: _normalizeStyle({
      'height': "".concat($props.rows * 40, "px")
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.subCategory.groups, function (group, index) {
    return _openBlock(), _createBlock(_component_GHSubGroup, {
      key: index,
      group: group,
      rows: $props.rows,
      onClickComp: $options.sendCompId
    }, null, 8, ["group", "rows", "onClickComp"]);
  }), 128))], 4)), [[_directive_loading, $data.isLoading]]), _createElementVNode("div", _hoisted_3, _toDisplayString($props.subCategory.name), 1)])]);
}